import { render } from "./storage-setings.vue?vue&type=template&id=73af2f0b"
import script from "./storage-setings.vue?vue&type=script&lang=js"
export * from "./storage-setings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__